import Docs, { getStaticProps } from 'routes/public/Docs'

export { getStaticProps }

export default Docs
